module.exports = {
  'unisex': { value: 'enum.sex.unisex', code: 'N' },
  'male': { value: 'enum.sex.male', code: 'M' },
  'female': { value: 'enum.sex.female', code: 'F' }
}
